module.exports = __webpack_public_path__ + "static/media/list_1.5b18c1f0.svg";